<template>
  <pt-previous-video-table class="pt-previous-video-table__withData" ref="table" :tableLabels="tableLabels" :tableData="tableData"
   @getTableData="getTableData" :totalNumber="totalNumber" :isOutside="isOutside">
   <slot/>
   </pt-previous-video-table>
</template>

<script>
import PtPreviousVideoTable from './index'
export default {
  name: 'pt-previous-video-table__withData',
  components: {
    'pt-previous-video-table': PtPreviousVideoTable
  },
  props: {
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 10
    },
    paramsData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isFromRouter: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  data () {
    return {
      tableData: [],
      totalNumber: 0,
      isOutside: false
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        if (this.isFromRouter) {
          this.isOutside = true
          this.getTableData(this.page)
        } else {
          this.resetPage()
        }
      }
    }
  },
  methods: {
    resetPage () {
      this.$refs.table.resetPage()
    },
    load () {
      this.$refs.table.load()
    },
    getTableData (page, next) {
      let data = {
        ...this.paramsData,
        pageable: {
          page: this.page,
          size: this.pageSize
        }
      }
      this.$store.dispatch('getVideoList', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.$message.error(err || '获取往期视频失败')
      })
    }

  }
}
</script>
